'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';

import { Review } from '@/fo/ui/review/catalog/base';

import { ReviewCard } from '../../../../../section/base/src/components/ReviewCard/ReviewCard';
import { useFilterSyncContext } from '../../hooks/FilterSyncContext';
import { ReviewsFilter } from '../../types';
import { ShowMoreButton } from '../ShowMoreButton/ShowMoreButton';

import { styles } from './ReviewsList.styles';

export interface ReviewsListProps {
  reviews: Review[];
  filters: ReviewsFilter;
  onFiltersChange: (filters: ReviewsFilter) => void;
  onLoadMore: () => void;
  isShowLoadMore?: boolean;
  isLoading?: boolean;
}

export function ReviewsList({
  reviews,
  onLoadMore,
  isShowLoadMore = false,
  isLoading = false
}: ReviewsListProps) {
  const slots = styles();
  const t = useTranslations();

  const filterRef = useRef<HTMLDivElement>(null);
  const { setContentFilterRef } = useFilterSyncContext();

  useEffect(() => {
    if (filterRef.current) {
      setContentFilterRef(filterRef.current);
    }
  }, [setContentFilterRef]);

  if (reviews.length === 0) {
    return <>{t('review.empty.reviews')}</>;
  }

  return (
    <>
      <div className={slots.base()}>
        <div className={slots.list()}>
          {reviews.map((review) => (
            <ReviewCard
              key={review.id}
              review={review}
              isShowMoreButtonShow={false}
              isShortComment={false}
              className={slots.card()}
            />
          ))}
        </div>

        {isShowLoadMore && (
          <ShowMoreButton
            onClick={onLoadMore}
            isLoading={isLoading}
          >
            {t('review.buttons.reviewsShowMore')}
          </ShowMoreButton>
        )}
      </div>
    </>
  );
}
